import React, { useState, useRef, useCallback } from "react";
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
} from "react-google-maps";

const SearchResultsMap = compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_MAPS_KEY}&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `560px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)(function(props) {
  var listings = props.listings || [];
  var userLocation = props.userLocation;
  var onSelectListing = props.onSelectListing;

  var [activeListing, setActiveListing] = useState(null);
  var mapRef = useRef(null);

  var validListings = listings.filter(function(l) { return l.latitude && l.longitude; });

  var handleMapMounted = useCallback(function(map) {
    mapRef.current = map;
    if (map && window.google && (validListings.length > 0 || userLocation)) {
      var bounds = new window.google.maps.LatLngBounds();
      validListings.forEach(function(l) {
        bounds.extend(new window.google.maps.LatLng(l.latitude, l.longitude));
      });
      if (userLocation && userLocation.lat && userLocation.lng) {
        bounds.extend(new window.google.maps.LatLng(userLocation.lat, userLocation.lng));
      }
      map.fitBounds(bounds);
    }
  }, [validListings, userLocation]);

  var defaultCenter = validListings.length > 0
    ? { lat: validListings[0].latitude, lng: validListings[0].longitude }
    : (userLocation || { lat: 42.4072, lng: -71.3824 });

  return (
    <GoogleMap ref={handleMapMounted} defaultZoom={10} defaultCenter={defaultCenter}>
      {userLocation && userLocation.lat && userLocation.lng && (
        <Marker
          position={userLocation}
          icon={window.google ? {
            path: window.google.maps.SymbolPath.CIRCLE,
            scale: 8,
            fillColor: "#2A3390",
            fillOpacity: 1,
            strokeColor: "white",
            strokeWeight: 2,
          } : undefined}
        />
      )}
      {validListings.map(function(listing) {
        var key = listing.id || listing.openHouseKey;
        return (
          <Marker
            key={key}
            position={{ lat: listing.latitude, lng: listing.longitude }}
            onClick={function() { setActiveListing(listing); }}
          />
        );
      })}
      {activeListing && (
        <InfoWindow
          position={{ lat: activeListing.latitude, lng: activeListing.longitude }}
          onCloseClick={function() { setActiveListing(null); }}
        >
          <div style={{ maxWidth: "220px" }}>
            {activeListing.photos && (
              <img
                src={typeof activeListing.photos === "string" ? activeListing.photos : (activeListing.photos[0] || "")}
                alt=""
                style={{ width: "100%", height: "110px", objectFit: "cover", borderRadius: "6px", marginBottom: "6px" }}
              />
            )}
            <div style={{ fontWeight: 700, fontSize: "13px", marginBottom: "2px" }}>
              {activeListing.title}
            </div>
            <div style={{ fontSize: "13px", color: "#2A3390", fontWeight: 800, marginBottom: "6px" }}>
              {activeListing.cost ? "$" + Number(activeListing.cost).toLocaleString() : ""}
            </div>
            <div style={{ display: "flex", gap: "6px" }}>
              <button
                onClick={function() { onSelectListing && onSelectListing(activeListing); }}
                style={{ flex: 1, padding: "6px 8px", background: "#2A3390", color: "white", border: "none", borderRadius: "6px", fontSize: "11px", fontWeight: 700, cursor: "pointer" }}
              >
                View
              </button>
              
               <a href={"https://www.google.com/maps/dir/?api=1&destination=" + activeListing.latitude + "," + activeListing.longitude}
                target="_blank"
                rel="noreferrer"
                style={{ flex: 1, padding: "6px 8px", background: "#D4922A", color: "#2c2416", border: "none", borderRadius: "6px", fontSize: "11px", fontWeight: 700, textAlign: "center", textDecoration: "none" }}
              >
                Directions
              </a>
            </div>
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
});

export default SearchResultsMap;